import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { useArgonController } from 'context';
import TemplateVisitor from 'pages/web/_TemplateVisitor';
import TemplateOpd from 'pages/adminOpd/_TemplateOpd';
import { CssBaseline, ThemeProvider } from '@mui/material';
import themeDark from 'assets/theme-dark';
import theme from 'assets/theme';
import Configurator from 'examples/Configurator';
import ArgonBox from 'components/ArgonBox';
import { Settings } from '@mui/icons-material';
import { setOpenConfigurator } from 'context';
import TemplateAdminPembangunan from 'pages/adminPembangunan/_TemplateAdmin';
import TemplateSuperAdmin from 'pages/superAdmin/_TemplateSuperAdmin';
import TemplatePimpinan from 'pages/pimpinan/_TemplatePimpinan';

function App() {
    const [controller, dispatch] = useArgonController();
    const { openConfigurator, darkMode } = controller;

    const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

    const configsButton = (
        <ArgonBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="3.5rem"
            height="3.5rem"
            bgColor="white"
            shadow="sm"
            borderRadius="50%"
            position="fixed"
            right="2rem"
            bottom="2rem"
            zIndex={99}
            color="dark"
            sx={{ cursor: "pointer" }}
            onClick={handleConfiguratorOpen}
        >
            <Settings fontSize="default" color="inherit" />
        </ArgonBox>
    );

    return (
        <ThemeProvider theme={darkMode ? themeDark : theme} >
            <CssBaseline />
            <Routes>
                <Route exact path='/a-pd/*' element={<TemplateOpd />} />
                <Route exact path='/a-pemb/*' element={<TemplateAdminPembangunan />} />
                <Route exact path='/admin/*' element={<TemplateSuperAdmin />} />
                <Route exact path='/adminp/*' element={<TemplatePimpinan />} />
                <Route exact path='/*' element={<TemplateVisitor />} />
            </Routes>
            <Configurator />
            {configsButton}
        </ThemeProvider>
    );
}

export default App;
